import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <LegalSection heading="Introduction">
        <p>
          Home Cart ("we", "us" or "our") respects your privacy. This Privacy
          Policy explains how we collect, use and protect the information you
          provide when you visit our website or contact us about our products,
          retail concept or business opportunities.
        </p>
      </LegalSection>

      <LegalSection heading="Information We Collect">
        <p>
          When you submit a request through our contact form, we may collect your
          name, email address, phone number, province and any details you choose
          to include in your message. We may also collect basic, non-identifying
          analytics about how visitors use our website.
        </p>
      </LegalSection>

      <LegalSection heading="How We Use Your Information">
        <p>
          We use the information you provide to respond to your inquiries, share
          information about Home Cart, and improve our website and customer
          experience. We do not sell your personal information.
        </p>
      </LegalSection>

      <LegalSection heading="Sharing of Information">
        <p>
          We only share information with trusted service providers who help us
          operate our website and respond to inquiries, or where required by law.
          These providers are obligated to protect your information.
        </p>
      </LegalSection>

      <LegalSection heading="Cookies">
        <p>
          Our website may use cookies and similar technologies to remember your
          preferences and understand how the site is used. You can control
          cookies through your browser settings.
        </p>
      </LegalSection>

      <LegalSection heading="Your Rights">
        <p>
          You may request access to, correction of, or deletion of the personal
          information we hold about you. To make a request, please contact us
          using the details below.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>
          If you have any questions about this Privacy Policy, please reach out to
          us at info@homecart.ca.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
